var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.currentServiceArea &&
      _vm.currentServiceArea.articles &&
      _vm.currentServiceArea.articles.length
        ? _c("knowledge-categories", {
            attrs: {
              "current-service-area": _vm.currentServiceArea,
              "service-areas": _vm.categoriesList,
              showDropdownForKnowledgeBrowse: _vm.showDropdownForKnowledgeBrowse
            },
            on: { clickBKRoute: _vm.clickBKRoute }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c("knowledge-services", {
            attrs: { articles: _vm.standardArticles }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86d0b0a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86d0b0a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledge-article/BrowseKnowledge.vue
// module id = null
// module chunks = 